import { Component, OnInit } from '@angular/core';

import { GridComponent } from '../../../components/admin/grid/grid.component';
import { ApiService } from '../../../services/api.service';
import { FormsModule } from '@angular/forms';
import { AuthService } from '../../../services/auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-dashboard',
  imports: [GridComponent, FormsModule],
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.scss',
})
export class DashboardComponent implements OnInit {
  selected: 'shows' | 'music' | 'users' = 'shows';
  shows: any[] = [];
  users: any[] = [];
  loadingShows = false;
  // modal state for create/edit
  isModalOpen = false;
  editMode = false; // false=create, true=edit
  modalModel: any = { title: '', date: '', location: '', url: '' };

  constructor(
    private auth: AuthService,
    private router: Router,
    private api: ApiService,
  ) {}

  ngOnInit(): void {
    if (!this.auth.isAuthenticated()) {
      this.router.navigate(['/admin/login']);
    }
    if (this.selected === 'shows') {
      this.loadShows();
    }
  }

  loadShows() {
    this.loadingShows = true;
    this.api.get<any[]>('/shows/shows?onlyUpcoming=false').subscribe({
      next: (data) => {
        this.shows = data ?? [];
        this.loadingShows = false;
      },
      error: () => (this.loadingShows = false),
    });
  }

  selectUserTab() {
    this.selected = 'users';
    if (this.users.length === 0) {
      this.loadUsers();
    }
  }

  loadUsers() {
    this.api.get<any[]>('/auth/users').subscribe({
      next: (data) => {
        this.users = data ?? [];
      },
    });
  }

  openCreateModal() {
    this.editMode = false;
    this.modalModel = { title: '', date: '', location: '', url: '' };
    this.isModalOpen = true;
  }

  openEditModal(row: any) {
    this.editMode = true;
    // clone to avoid editing the list directly
    this.modalModel = { ...row };
    // normalize date to yyyy-mm-dd for date input if present
    if (this.modalModel.date) {
      try {
        this.modalModel.date = new Date(this.modalModel.date)
          .toISOString()
          .slice(0, 10);
      } catch {}
    }
    this.isModalOpen = true;
  }

  closeModal() {
    this.isModalOpen = false;
  }

  submitModal() {
    const payload = { ...this.modalModel };
    if (this.editMode && payload.id) {
      this.api.put(`/shows/shows/${payload.id}`, payload).subscribe({
        next: () => {
          this.closeModal();
          this.loadShows();
        },
        error: () => alert('Update failed'),
      });
    } else {
      this.api.post('/shows/shows', payload).subscribe({
        next: () => {
          this.closeModal();
          this.loadShows();
        },
        error: (e) => alert('Create failed'),
      });
    }
  }

  onGridCreate() {
    this.openCreateModal();
  }
  onGridEdit(row: any) {
    this.openEditModal(row);
  }
  onGridDelete(row: any) {
    if (!confirm('Delete this show?')) return;
    this.api.delete(`/shows/shows/${row.id}`).subscribe({
      next: () => this.loadShows(),
      error: () => alert('Delete failed'),
    });
  }

  onUserCreate() {
    alert('User create not implemented');
  }
  onUserEdit(row: any) {
    alert('User edit not implemented');
  }
  onUserDelete(row: any) {
    alert('User delete not implemented');
  }
}
